import { parseDate } from '@utils/date';

export const YEAR_GRID_SIZE = 12;

export const toDate = (v: string | Date | null | undefined): Date | undefined => {
  if (!v) return undefined;
  const d = parseDate(v);
  return isNaN(d.getTime()) ? undefined : d;
};

// Pull a date back inside [min, max]. Used when committing a month from the
// month grid: a month is selectable if *any* of its days are in range, but the
// commit lands on the first of the month, which can fall before minDate (e.g.
// picking June with minDate = June 3). Clamping keeps the emitted value within
// the configured bounds.
export const clampToRange = (date: Date, min?: Date, max?: Date): Date => {
  if (min && date < min) return min;
  if (max && date > max) return max;
  return date;
};

// The year grid shows a fixed window of YEAR_GRID_SIZE years. Returns the
// [start, end] of the window containing `year`.
export const getYearPeriod = (year: number): [number, number] => {
  const end = Math.ceil(year / YEAR_GRID_SIZE) * YEAR_GRID_SIZE;
  return [end - (YEAR_GRID_SIZE - 1), end];
};
